import { render, staticRenderFns } from "./PowerbiVariance.vue?vue&type=template&id=70f212e7&scoped=true"
import script from "./PowerbiVariance.vue?vue&type=script&lang=js"
export * from "./PowerbiVariance.vue?vue&type=script&lang=js"
import style0 from "./PowerbiVariance.vue?vue&type=style&index=0&id=70f212e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f212e7",
  null
  
)

export default component.exports